export default __webpack_public_path__ + "static/media/5.b131c33a.jpg";